<template>
    <div v-if="isOpen" class="catalog-window">
        <!-- CATEGORIES -->
        <div class="catalog-window__categories">
            <!-- ITEM -->
            <NuxtLink 
                v-for="(category, idx) in categories"
                :key="idx"
                :to="localePath(category.route)" 
                class="catalog-window__categories__item"
            >
                <div class="catalog-window__categories__item__img">
                    <img v-if="category.img" :src="category.img" :alt="category.name">
                    <img v-else src="@/themes/ecaterix/assets/images/placeholders/product-image-not-found.png" :alt="category.name">
                </div>
                <h3 :title="category.name">{{ category.name }}</h3>
            </NuxtLink>
        </div>
    </div>
</template>

<script>
import VueTypes from "vue-types";
import { ParentCategoryItem } from './../../types'

export default {
    name: 'CatalogWindow',
    props: {
        isOpen: VueTypes.bool.isRequired,
        categories: VueTypes.arrayOf(ParentCategoryItem).isRequired
    },
}
</script>

<style lang="scss">
@import '~/themes/ecaterix/assets/styles/utils.scss';
@import './styles.scss';
</style>